<script setup>
if (window.location.hostname == 'h5.aetherisacademy.com') {
  window.location.href = window.location.origin + '/dist/superpowers/index';
}
</script>

<template>
  <RouterView v-slot="{ Component }">
    <transition
      name="fade"
      mode="out-in"
    >
      <component :is="Component" />
    </transition>
  </RouterView>
</template>

<style lang="scss">
@import '@/assets/scss/index.scss';
</style>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
